'use client';

import { motion } from 'framer-motion';

import type { ReactNode } from 'react';

type SharedElementType = 'image' | 'title' | 'tag';

interface SharedLayoutItemProps {
  id: string;
  className?: string;
  children: ReactNode;
  type: SharedElementType;
}

export function SharedLayoutItem({
  id,
  type,
  children,
  className = '',
}: SharedLayoutItemProps) {
  const layoutId = `${type}-${id}`;

  const getTransitionSettings = () => {
    switch (type) {
      case 'image':
        return {
          type: 'spring',
          bounce: 0.1,
          duration: 0.7,
          stiffness: 280,
          damping: 28,
        };
      case 'title':
        return {
          type: 'spring',
          bounce: 0.2,
          duration: 0.2,
          stiffness: 300,
          damping: 30,
        };
      case 'tag':
        return {
          type: 'spring',
          bounce: 0.3,
          duration: 0.2,
          stiffness: 350,
          damping: 35,
        };
      default:
        return {
          type: 'spring',
          bounce: 0.2,
          duration: 0.6,
        };
    }
  };

  return (
    <motion.div
      layoutId={layoutId}
      className={className}
      transition={getTransitionSettings()}
      layout
    >
      {children}
    </motion.div>
  );
}
